<template>
  <div
    v-if="isHeaderVisible"
    id="report-top-container"
    class="report-top"
  >
    <div
      id="report-top__wrapper-id"
      class="report-top__wrapper"
    >
      <div class="report-top__info">
        <div class="report-top__info-left">
          <div class="report-top__general-info">
            <div
              class="report-top__general-info-back"
              @click="$router.push({ name: 'source-of-funds' })"
            >
              <gl-icon
                :height="24"
                name="report-back-arrow"
                :width="24"
              />
            </div>
            <GlBlockchainIcon
              v-if="getReportHeaderData?.formattedData?.coinKey"
              :blockchain-icon="getReportHeaderData?.formattedData?.coinKey"
            />
            <VueSkeletonLoader
              v-if="getReportHeaderData?.reportPartsLoading"
              animation="wave"
              class="report-top__general-info-loader"
              :color="'#bec3d8'"
              :height="20"
              :radius="'2'"
              type="rect"
            />
            <div
              v-else
              class="report-top__general-info-wallet"
            >
              {{
                !isDesktop
                  ? trancateString(
                      getReportHeaderData?.formattedData?.walletAddress,
                      8,
                  )
                  : getReportHeaderData?.formattedData?.walletAddress
              }}
            </div>
            <GlInfoTag
              v-if="getReloadInfo.isNewDataAvailable"
              size="small"
              type="gradient"
            >
              New Data
            </GlInfoTag>
          </div>
        </div>
        <div class="report-top__info-right">
          <transition name="fade">
            <ReloadButton
              v-if="isReloadButtonVisible"
              :loading="getReportHeaderData?.reloadReportLoading"
              :reload-info="getReloadInfo"
              @on-reload="emitReportHeader({ eventType: 'reload' })"
            />
          </transition>
        </div>
      </div>
      <!-- <div class="report-top__anchors">
        <div
          class="report-top__anchors-item"
          :class="{ active: activeSection === 'address' }"
          @click="scrollToSection('address', 0, scrollOffsetFromAnchor)"
        >
          <span>Address Information</span>
        </div>
        <div
          class="report-top__anchors-item"
          :class="{
            active: activeSection === 'risks' || activeSection === 'risks-card',
          }"
          @click="scrollToSection('risks', 0, scrollOffsetFromAnchor)"
        >
          <gl-icon
            v-if="!getPurchasedInfo?.risks"
            :height="24"
            :name="
              activeSection === 'risks' || activeSection === 'risks-card'
                ? 'anchor-lock-section-blue'
                : 'anchor-lock-section'
            "
            :width="24"
          />
          <span>Risk Score</span>
        </div>
        <div
          class="report-top__anchors-item"
          :class="{
            active: activeSection === 'tier2' || activeSection === 'tier2-card',
          }"
          @click="scrollToSection('tier2', 0, scrollOffsetFromAnchor)"
        >
          <gl-icon
            v-if="!getPurchasedInfo?.tier2"
            :height="24"
            :name="
              activeSection === 'tier2' || activeSection === 'tier2-card'
                ? 'anchor-lock-section-blue'
                : 'anchor-lock-section'
            "
            :width="24"
          />
          <span>Money Trail</span>
        </div>
        <div
          class="report-top__anchors-item"
          :class="{
            active: activeSection === 'full' || activeSection === 'full-card',
          }"
          @click="scrollToSection('full', 0, scrollOffsetFromAnchor)"
        >
          <gl-icon
            v-if="!getPurchasedInfo?.full"
            :height="24"
            :name="
              activeSection === 'full' || activeSection === 'full-card'
                ? 'anchor-lock-section-blue'
                : 'anchor-lock-section'
            "
            :width="24"
          />
          <span>Transactions</span>
        </div>
      </div> -->
      <div
        v-if="getIsLegacy"
        class="report-top__banner-wrapper"
        :class="{ 'report-top__banner-wrapper--warning': getIsLegacy }"
      >
        <div class="report-top__banner">
          <LegacyReportBanner v-if="getIsLegacy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// vuex
import { mapGetters, mapMutations } from 'vuex'
// components
import VueSkeletonLoader from 'skeleton-loader-vue'
import GlIcon from '@/components/gl-icon'
import GlBlockchainIcon from '@/components/gl-blockchain-icon'
import ReloadButton from '@/pages/report/components/ReloadButtonV2'
import LegacyReportBanner from '@/pages/report/components/banners/LegacyReportBanner.vue'
import GlInfoTag from '@/components/gl-info-tag'
// mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'
// utils
import { trancateString } from '@/utils/text-formatter'
import { getOffsetTopInContainer } from '@/utils/scroll-to'

const partIds = ['address', 'risks', 'tier2', 'full']

export default {
  components: {
    VueSkeletonLoader,
    GlIcon,
    GlBlockchainIcon,
    ReloadButton,
    LegacyReportBanner,
    GlInfoTag
  },
  mixins: [deviceWidthMixin],
  data() {
    return {
      activeSection: 'address',
      scrollOffsetFromAnchor: -200,
      scrollOffsetFromAnchorCard: -240,
    }
  },
  computed: {
    ...mapGetters('report', [
      'getReloadInfo',
      'getPurchasedInfo',
      'getNoSentTransactions',
      'getCurrentPrices',
      'getReportHeaderData',
      'getIsGenerateReportLoaderVisible',
      'getIsLegacy',
      'getExampleId',
    ]),
    ...mapGetters('user', ['isLogin']),
    isHeaderVisible() {
      return (
        Object.keys(this.getReportHeaderData).length &&
        !this.getReportHeaderData?.startAddressCheckLoading &&
        !this.getIsGenerateReportLoaderVisible
      )
    },
    isReloadButtonVisible() {
      return (
        this.isLogin &&
        this.getReloadInfo.isNewDataAvailable &&
        this.getReloadInfo.reloadAvailable &&
        !this.getReportHeaderData?.reportPartsLoading &&
        !this.getExampleId &&
        !this.getIsLegacy
      )
    },
  },
  mounted() {
    this.observeActiveSection()
  },
  beforeDestroy() {
    const container = document.getElementById('main-container')
    container?.removeEventListener('scroll', this._onSectionScroll)
  },
  methods: {
    ...mapMutations({
      SET_REPORT_HEADER_EMIT: 'report/SET_REPORT_HEADER_EMIT',
    }),
    trancateString,
    getOffsetTopInContainer,
    scrollToSection(anchor, timeout = 0, offset = 0) {
      if (!anchor) return
      const el = document.getElementById(anchor)
      const container = document.getElementById('main-container')
      if (el && container) {
        setTimeout(() => {
          const elTop = this.getOffsetTopInContainer(el, container) + offset
          container.scrollTo({ top: elTop, behavior: 'smooth' })
        }, timeout)
      } else if (this.getPurchasedInfo[anchor]) {
        this.activeSection = anchor
      }
    },
    observeActiveSection() {
      const container = document.getElementById('main-container')
      if (!container) return

      const sectionIds = [...partIds]

      const checkActiveSection = () => {
        const scrollTop = container.scrollTop
        const containerHeight = container.clientHeight
        const scrollHeight = container.scrollHeight

        let current = 'address'

        for (let i = sectionIds.length - 1; i >= 0; i--) {
          const id = sectionIds[i]
          const el = document.getElementById(id)
          if (el) {
            const offsetTop = this.getOffsetTopInContainer(el, container)
            if (scrollTop >= offsetTop + this.scrollOffsetFromAnchor - 10) {
              current = id
              break
            }
          }
        }

        const isScrolledToBottom =
          scrollTop + containerHeight >= scrollHeight - 20

        if (isScrolledToBottom) {
          current = sectionIds[sectionIds.length - 1]
        }

        this.activeSection = current

        this.$nextTick(() => {
          const anchor = document.querySelector('.report-top__anchors')
          if (anchor) {
            anchor.scrollLeft =
              document.querySelector('.report-top__anchors-item.active')
                ?.offsetLeft - 16
          }
        })
      }

      this._onSectionScroll = () => {
        requestAnimationFrame(checkActiveSection)
      }

      container.addEventListener('scroll', this._onSectionScroll)
    },
    emitReportHeader(type) {
      this.SET_REPORT_HEADER_EMIT(type)
    },
  },
}
</script>

<style>
.report-top {
  width: var(--full-width);
  background-color: var(--white);
  border-top: 1px solid var(--Basic-100);
  box-shadow: 0px 1px 4px 0px rgba(9, 21, 64, 0.08);
  transition: transform 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  transform: translate(0, var(--header-height));
}
.header-hidden .report-top {
  transform: translate(0, 0);
}

.report-top .info-tag {
  white-space: nowrap;
}

.report-top .highlight-section {
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
  margin: 0 auto;
  padding: 16px;
}

.report-top:has(.highlight-section) {
  z-index: 102;
}

.report-top__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
}
.report-top__general-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.report-top__general-info-back {
  margin-left: -40px;
  cursor: pointer;
}
.report-top__general-info-back svg {
  display: block;
}
.report-top__general-info-wallet {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.5px;
}
.report-top__general-info-loader.loader {
  width: 55vw !important;
  max-width: 350px;
}

.report-top__anchors {
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
  display: flex;
  gap: 24px;
  overflow: auto;
}
.report-top__anchors::-webkit-scrollbar {
  display: none;
}
.report-top__anchors-item {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 48px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  transition: color 0.3s ease;
}
.report-top__anchors-item span {
  margin-bottom: 2px;
}
.report-top__anchors-item:after {
  content: '';
  width: 100%;
  height: 2px;
  background-color: transparent;
  border-radius: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: background-color 0.3s ease;
}
.report-top__anchors-item.active {
  color: #194bfb;
}
.report-top__anchors-item.active::after {
  background-color: #194bfb;
}
.report-top__anchors-item--disabled {
  cursor: not-allowed;
}

.report-top__info {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 40px;
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
  margin-bottom: 16px;
}

.report-top__info-left {
  display: flex;
  align-items: center;
}

.report-top__info-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  white-space: nowrap;
}

@media (max-width: 1339px) {
  .report-top__general-info-back {
    margin-left: 0;
  }
}
@media (max-width: 1200px) {
  .report-top__general-info-loader.loader {
    max-width: 160px;
  }
}

@media (max-width: 767px) {
  .report-top__general-info {
    flex-wrap: wrap;
    gap: 8px;
  }
  .report-top__general-info-wallet {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.2px;
  }
  .report-top .highlight-section {
    padding: 8px;
  }
  .report-top__info-right {
  }
  .report-top__info-right .reload-report__text {
    display: none;
  }
  .report-top__info-right .reload-report {
    padding: 0px 8px 0px 8px;
  }
}

@media (min-width: 768px) {
  .buy-block--sticked .report-top {
    box-shadow: unset;
  }
}
</style>

<style scoped>
.report-top__banner-wrapper {
  min-height: 64px;
  height: var(--report-header-banner-height);
  width: 100%;
  display: flex;
  justify-content: center;
}
.report-top__banner-wrapper--warning {
  background: linear-gradient(0deg, #ffa305 0%, #ffa305 100%), #fff;
}
.report-top__banner {
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
}
</style>
